// @flow

export const TOGGLE_MENU = 'navigationdrawer.toggle.menu';
